export default {
  getInfo: {
    method: 'get',
    url: '/client/auth/user'
  },
  updateInfo: {
    method: 'put',
    url: '/client/auth/user'
  },

  findUser: {
    method: 'get',
    url: '/client/auth/user/find?key=KEY'
  },
  authInviteUser: {
    // api invite user
    method: 'get',
    url: '/client/auth/invite-user?token=TOKEN'
  }
}
